module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace3_dettaglio-48af6dd76a844d97aad7244d0820f322.jpg";